;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from '@sentry/nextjs'

import environments from '@/utils/environments'
import {
  GOOGLE_MAPS_EPOCH_MISMATCH_FINGERPRINT,
  isGoogleMapsEpochMismatch,
  isGoogleMapsModuleLoadFailure,
} from '@/utils/googleMapsEpochMismatch'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
const dev = process.env.NODE_ENV && process.env.NODE_ENV === 'development'
const forceActive = /(T|t)rue[ ]*$/.test(process.env.NEXT_PUBLIC_SENTRY_FORCE_ACTIVE || process.env.SENTRY_FORCE_ACTIVE || "")
const debug = /(E|e)nable(d|)[ ]*$/.test(process.env.NEXT_PUBLIC_SENTRY_DEBUGGING || process.env.SENTRY_DEBUGGING || "")
const logs = /(E|e)nable(d|)[ ]*$/.test(process.env.NEXT_PUBLIC_SENTRY_LOGS || process.env.SENTRY_LOGS || "")
const environment = environments[process.env.NEXT_PUBLIC_ENV!] ?? process.env.NEXT_PUBLIC_ENV
const buildId = process.env.NEXT_PUBLIC_BUILD_ID

Sentry.init({
  release: buildId,
  dsn: SENTRY_DSN,
  enabled: !dev || forceActive,
  debug: debug,
  environment,
  // integrations: [
  //   Sentry.replayIntegration(),
  // ],
  // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  includeLocalVariables: true,
  tracesSampleRate: 0.1,
  enableLogs: logs,
  // Screen out errors that don't originate from our code. These come from
  // browser extensions and injected userscripts (Tampermonkey/Greasemonkey/
  // Violentmonkey), e.g. `*.user.js` running on Smart-TV browsers, and are
  // not actionable for us.
  denyUrls: [
    // Userscripts injected by extensions use the `.user.js` convention.
    /\.user\.js/i,
    // Browser extension protocols.
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-(web-)?extension:\/\//i,
  ],
  beforeSend(event) {
    // Google Maps epoch mismatches aren't actionable for us, but we keep
    // reporting them at `info` so the trend stays visible — a volume spike
    // would mean the renderer is failing for reasons beyond a routine rollout.
    // The stable fingerprint collapses every epoch pair into one issue group,
    // which can then be archived until it escalates. The SDK failing to fetch
    // one of its own lazy modules is the same class of `beta` renderer noise,
    // so it joins that group.
    if (isGoogleMapsEpochMismatch(event) || isGoogleMapsModuleLoadFailure(event)) {
      event.fingerprint = [GOOGLE_MAPS_EPOCH_MISMATCH_FINGERPRINT]
      event.level = 'info'
    }

    return event
  },
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
